<mat-card class="sticky-footer-shadow tw-rounded-b-none">
    <mat-card-content
        class="tw-grid tw-grid-cols-8 lg:tw-grid-cols-10 tw-text-center tw-h-fit tw-items-center tw-justify-items-center tw-gap-2"
    >
        <div class="lg:tw-col-span-2 tw-hidden lg:tw-flex"></div>

        @for (day of daysOfWeek; track $index) {
            <div>
                {{ day.name | titlecase }}
                <mat-divider></mat-divider>
                {{ weeklyTotalsFormGroup.controls[day.name + "Total"].value }}
            </div>
        }

        <div>
            Week Total
            <mat-divider></mat-divider>
            {{ weeklyTotalsFormGroup.controls.weekTotal.value }}
        </div>
    </mat-card-content>
</mat-card>
